import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import StripeClone from "./App"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
      <StripeClone />
  </React.Fragment>
);